import styled from 'styled-components'
import React, { useState, } from 'react'
import { TextField, } from '@mui/material'
import { useDispatch, } from 'react-redux'
import { useLocation, useNavigate, } from 'react-router-dom'
import { Search as SearchIcon, } from '@mui/icons-material'

import { logout, } from '@reducers'

const Container = styled.header`
  display: flex;
  justify-content: space-between;
  height: 76px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
  background: linear-gradient(180deg, rgba(250, 252, 255, 0.96) 0%, rgba(243, 247, 252, 0.92) 100%);
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
  backdrop-filter: blur(10px);
  z-index: 100;
  padding: 0 28px 0 34px;
  align-items: center;
  gap: 20px;

  .title-button {
    border: 0;
    padding: 0;
    background: transparent;
    color: rgb(30, 41, 59);
    font-size: 25px;
    font-weight: 800;
    letter-spacing: -0.03em;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      color: rgb(67, 81, 249);
    }
  }

  .controls {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-left: auto;
  }

  .agent-search-input {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px 6px 14px;
    min-width: 300px;
    border-radius: 14px;
    border: 1px solid rgba(148, 163, 184, 0.28);
    background-color: rgba(255, 255, 255, 0.9);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.75);

    .search-field {
      flex: 1;

      .MuiOutlinedInput-root {
        background: transparent;
        font-size: 14px;

        input {
          padding: 8px 0;
          color: rgb(51, 65, 85);
        }

        fieldset {
          border: 0;
        }

        &:hover fieldset, &.Mui-focused fieldset {
          border: 0;
        }
      }
    }
  }

  .search-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    color: white;
    background: linear-gradient(135deg, rgb(67, 81, 249) 0%, rgb(79, 70, 229) 100%);
    box-shadow: 0 8px 18px rgba(67, 81, 249, 0.24);
    cursor: pointer;
    transition: 0.2s ease transform, 0.2s ease box-shadow, 0.2s ease opacity;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 10px 20px rgba(67, 81, 249, 0.28);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .logout-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    padding: 0 16px;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(148, 163, 184, 0.26);
    color: rgb(71, 85, 105);
    cursor: pointer;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: -0.01em;
    transition: 0.2s ease background-color, 0.2s ease color, 0.2s ease border-color;

    &:hover {
      background-color: rgba(255, 255, 255, 0.96);
      color: rgb(30, 41, 59);
      border-color: rgba(148, 163, 184, 0.42);
    }
  }
`

function Header() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const [ agentSearchValue, setAgentSearchValue, ] = useState('')

  const onAgentSearchClick = () => {
    const urlParams = new URLSearchParams(location.search)

    if(urlParams.get('search-agent') !== agentSearchValue) {
      if(!agentSearchValue) {
        navigate('/')
      } else {
        navigate(`/?search-agent=${ agentSearchValue }`)
      }
    }
  }

  const onTitleClick = () => {
    navigate('/')
  }

  const onLogoutClick = () => {
    if(confirm('로그아웃 하시겠습니까?')) {
      dispatch(logout())
    }
  }

  return (
    <Container>
      <button className='title-button' type='button' onClick={ onTitleClick }>
        브릿카 상황실 대시보드
      </button>
      <div className='controls'>
        <div className='agent-search-input'>
          <TextField
            className='search-field'
            size='small'
            placeholder='평가사 이름 검색'
            value={ agentSearchValue }
            onChange={ e => setAgentSearchValue(e.target.value) }
            inputProps={{ type: 'search', }}
            onKeyDown={
              e => {
                if(e.key === 'Enter') {
                  onAgentSearchClick()
                }
              }
            }
          />
          <a className='search-button' onClick={ onAgentSearchClick }>
            <SearchIcon />
          </a>
        </div>
        <a className='logout-button' onClick={ onLogoutClick }>
          로그아웃
        </a>
      </div>
    </Container>
  )
}

export default Header
